let header = new Headers({
  "Access-Control-Allow-Origin": "*",
//   "content-type": "application/json",
  "content-type": "multipart/form-data"
});

export function getData() {
  return {
    method: "GET",
    mode: "cors",
    header: header,
    body: null
  };
}

export function postData(data) {
  return {
    method: "POST",
    mode: "cors",
    header: header,
    body: JSON.stringify(data)
  };
}
